import React, { useState } from "react";
import "./RegalPageWrapper.scss"
import Footer from "./components/Footer/Footer";
import MenuNavbarMini from "../HospitalityDefault/components/Navbar/MenuNavbarMini";

const RegalPageWrapperMiniNavbar = ({ children }) => {

    return (
        <div className="RegalPageWrapper">
            <MenuNavbarMini />
            {children}
            <Footer />
        </div>
    )
}
export default RegalPageWrapperMiniNavbar